import { Component, OnInit } from '@angular/core';
import {NativeServiceApiProvider} from "../../../services/native-api-provider.service";
import {of, switchMap, tap, zip} from "rxjs";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {SpinnerService} from "../../../utils/services/spinner.service";
import {AuthorizationServiceProvider} from "../../../auth_profile/services/authorization-service.provider";
import {AuthorizedUserDetailsService} from "../../../auth_profile/services/api/authorization.api";
import {V3ExamSession, V3ExamSessionPart} from "../../model/v3/cspa";

@Component({
    selector: 'app-exam-details',
    templateUrl: './exam-details.component.html',
    styleUrls: ['./exam-details.component.scss'],
    standalone: false
})
export class ExamDetailsComponent implements OnInit {
  uuId: string
  section: string
  chapter: string
  exerciseSet: string
  session: V3ExamSession
  sessionParts: V3ExamSessionPart[]
  isOffline = false
  isSummary: boolean = false
  basePath: string
  private personId?: number
  constructor(private provider: NativeServiceApiProvider,
              private route: ActivatedRoute,
              private spinner: SpinnerService,
              private auth: AuthorizationServiceProvider,
              private router: Router) { }

  ngOnInit(): void {
    this.prepareBasePath()
    this.route.paramMap.pipe(
      tap( (params: ParamMap) => {
        this.uuId = params.get("sessionId")
        this.section = params.get("section");
        this.chapter = params.get("chapter");
        this.exerciseSet = params.get("exerciseSet");
      }),
      switchMap( _ => this.loadData()),
    ).subscribe()
  }

  prepareBasePath() {
    zip(this.route.parent.url, this.route.url).subscribe(([p, c]) => {
        let segments = [p[0], c[0]]
        this.basePath = segments.join("/")
        this.isSummary = c[c.length - 1].path == 'finish'
      })
  }

  loadData() {
    return this.spinner.trace(
      this.provider.cspaV3().pipe(
        switchMap((api) => zip(of(api), api.isOffline())),
        switchMap(([api, isOffline]) => {
          if (isOffline)
            return of(null).pipe(
              tap(_ => this.isOffline = true)
            )
          else
            return zip(of(api), this.auth.getAuthDetailsService()).pipe(
              switchMap(([api, authDetailsApi]) =>
                this.getPersonId(authDetailsApi).pipe(
                  switchMap(personId =>
                    zip(
                      api.getExamSession(personId, this.uuId),
                      api.findExamSessionsParts(personId, this.uuId),
                    ),
                  ),
                  tap(([session, sessionParts]) => {
                    this.session = session
                    this.sessionParts = sessionParts
                  }),
                ),
              )
            )
        }),
      ),
    )
  }

  getExerciseRouterLink() {
    return `/${this.basePath}`
  }

  getChapterRouterLink() {
    return `/${this.basePath}/${this.exerciseSet}/${this.chapter}`
  }

  getAccent() {
    return `accent stg-${this.session?.chapterName.slice(-2).trim()}`
  }

  getChapter() {
    return this.session?.chapterName || '-'
  }

  getExamName() {
    return this.session?.examName || '-'
  }

  getExerciseSet() {
    return this.exerciseSet
  }

  isSampleExam() {
    return this.session?.examName.split(" ")[1] == "0"
  }

  getBackButtonRouterLink() {
    this.route.url.subscribe(paths => {
      if(paths.find(el => el.path == 'finish')){
        this.router.navigate(["../../../../../"], { relativeTo: this.route })
      }
      else {
        this.router.navigate(["../../../../"], { relativeTo: this.route })
      }
    })
  }

  private getPersonId(authDetailsApi: AuthorizedUserDetailsService) {
    if (this.personId != null) {
      return of(this.personId);
    }
    return authDetailsApi.getSelfPersonId().pipe(
      tap(personId => this.personId = personId),
    );
  }
}
